<template>
  <div class="page gczp">

    <div :class="contentClass">
      <m-puppet
        v-if="currentTab === 0"
        :tabData="this.tabs[this.currentTab]"
        :category="picCategory"
        @picshow="showPic"
        @showPicker="categoryPicker = true"
      ></m-puppet>
      <m-script
        v-if="currentTab === 1"
        :tabData="this.tabs[this.currentTab]"
        @pdfshow="showPdf"
      ></m-script>
      <m-prop
        v-if="currentTab === 2"
        :tabData="this.tabs[this.currentTab]"
        @picshow="showPic"
      ></m-prop>
    </div>

    <BottomNav
      :page="page"
      :items="tabs"
      :active="currentTab"
      class="gczp-tabnav"
      btnclass="gczp-nav"
      @changeNav="changeTab"
      wrap
    ></BottomNav>

    <PicShow
      v-if="picPage"
      :content="content"
      :headers="headers"
      @close="picPage = false"
    ></PicShow>

    <PdfContent
      v-if="pdfPage"
      :content="pdfData"
      :headers="pdfheaders"
      @close="pdfPage = false"
    ></PdfContent>

    <CategoryPicker
      :show="categoryPicker"
      @submit="changeCategory"
      @hidePicker="categoryPicker = false"
    ></CategoryPicker>
  </div>
</template>

<script>
import { mapState } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import Puppet from "./Puppet";
import Script from "./Script";
import Prop from "./Prop";
import PicShow from "@/components/PicShow";
import PdfContent from "./PdfContent";
import CategoryPicker from "./CategoryPicker";

export default {
  components: {
    BottomNav,
    "m-puppet": Puppet,
    "m-script": Script,
    "m-prop": Prop,
    PicShow,
    PdfContent,
    CategoryPicker
  },
  data() {
    return {
      page: "gczp",
      currentTab: 0,
      // 图片内容页
      picPage: false,
      content: {},
      headers: [
        { tag: "title", name: "标题" },
        { tag: "category", name: "类别" },
        { tag: "age", name: "年代" },
        { tag: "region", name: "地域" },
        { tag: "broken", name: "完残" },
        { tag: "material", name: "材质" },
        { tag: "size", name: "尺寸" },
        { tag: "status", name: "现状" },
        { tag: "rank", name: "级别" },
        { tag: "source", name: "来源" },
        { tag: "keywords", name: "关键词" },
        { tag: "comment", name: "简介" },
        { tag: "view_count", name: "点击率" },
        { tag: "no", name: "登记号" },
        { tag: "collected_date", name: "入藏时间" },
        { tag: "collected_address", name: "入藏地点" }
      ],
      // 图片分类选择器
      picCategory: "",
      categoryPicker: false,
      // PDF内容页
      pdfPage: false,
      pdfData: {},
      pdfheaders: [
        { tag: "charge", name: "责任者" },
        { tag: "age", name: "年代" },
        { tag: "region", name: "地域" },
        { tag: "museum", name: "馆藏地" },
        { tag: "no", name: "登记号" }
      ],
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.gczp,
      gczp: "gczp"
    }),
    contentClass() {
      return `${this.page}-tabs`;
    }
  },
  mounted() {},
  methods: {
    changeTab(activeNum) {
      this.currentTab = activeNum;
    },
    showPic(data) {
      this.content = data;
      this.picPage = true;
    },
    showPdf(data) {
      const pdfData = data;
      pdfData.museum = pdfData.museum || "中国美术学院民艺博物馆";
      this.pdfData = pdfData;
      this.pdfPage = true;
    },
    changeCategory(category) {
      this.picCategory = category;
      this.categoryPicker = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.gczp-tabnav {
  bottom: 1rem;
}
.gczp-nav {
  margin: 0 1rem;
  @include tab2;

  .icon {
    width: 3.5rem;
    height: 3.5rem;
    background-size: 3rem 3rem;
  }
}
</style>
